import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_DEVICE_PERMISSION = `${API_URL}/api/v1/kid/permission`;
export const BLOCK_SETTING = `${API_URL}/api/v1/parent/block-setting`;
export const WIPE_DEVICE_DATA = `${API_URL}/api/v1/parent/push-notification`;
export const DELETE_DEVICE = `${API_URL}/api/v1/parent/kid-device`;
export const FIND_DEVICE = `${API_URL}/api/v1/parent/push-notification`;
export const LOCK_DEVICE = `${API_URL}/api/v1/parent/push-notification`;

export function devicePermission(deviceId) {
    return axiosInstance({
        url: GET_DEVICE_PERMISSION,
        method: "GET",
        params: deviceId
    })
}
export function blockSetting(data) {
    return axiosInstance({
        url: BLOCK_SETTING,
        method: "post",
        data
    })
}
export function wipeDeviceData(data) {
    return axiosInstance({
        url: WIPE_DEVICE_DATA,
        method: "post",
        data
    })
}

export function deleteDevice(payload) {
    return axiosInstance({
        url: DELETE_DEVICE,
        method: "put",
        data: payload
    })
}
export function findDevice(data) {
    return axiosInstance({
        url: FIND_DEVICE,
        method: "post",
        data
    })
}
export function lockDevice(data) {
    return axiosInstance({
        url: LOCK_DEVICE,
        method: "post",
        data
    })
}